import { css } from '@emotion/css';

import {
  MEDIUM_DEVICE_MQ,
  SMALL_DEVICE_MQ,
  Spacing,
} from 'apps/shared/scripts/styles/constants';

export const layoutClassName = css({
  alignItems: 'stretch',
  background: '#FFFFFF',
  display: 'flex',
  minHeight: '100vh',
  paddingTop: 68,
  transition: '0.6s',
  width: '100%',
  [MEDIUM_DEVICE_MQ]: {
    paddingLeft: 250,
  },
  [SMALL_DEVICE_MQ]: {
    background: '#FAFAFA',
  },
});

export const wrapperClassName = css({
  width: '100%',
});

export const containerClassName = css({
  '--bs-gutter-x': '1.5rem',
  '--bs-gutter-y': 0,
  marginLeft: 'auto',
  marginRight: 'auto',
  maxWidth: 1120,
  paddingLeft: 'var(--bs-gutter-x)',
  paddingRight: 'var(--bs-gutter-x)',
  [MEDIUM_DEVICE_MQ]: {
    paddingLeft: Spacing.XL,
    paddingRight: Spacing.XL,
  },
});

export const innerClassName = css({
  paddingTop: Spacing.XL,
});
